import { Logo } from "@/components/Logo";
import { MessageCircle, Instagram, Music2, Facebook, Mail, MapPin } from "lucide-react";
import { useSettings, buildWhatsAppLink } from "@/context/SettingsContext";
import { Link } from "react-router-dom";

export default function Footer() {
  const { settings } = useSettings();
  const s = settings || {};
  return (
    <footer className="bg-black border-t border-[#1A1A1A] pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo size="lg" />
            <p className="text-white/55 mt-5 max-w-sm leading-relaxed text-sm" data-testid="footer-tagline">
              {s.footer_tagline}
            </p>
            <a
              href={buildWhatsAppLink(s)}
              target="_blank"
              rel="noreferrer"
              className="btn-whatsapp mt-6 text-sm"
              data-testid="footer-whatsapp-button"
            >
              <MessageCircle className="w-4 h-4" />
              {s.whatsapp_number || "Chat on WhatsApp"}
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="text-[0.65rem] uppercase tracking-[0.28em] text-[#D4AF37] mb-4">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#collections" className="text-white/70 hover:text-[#D4AF37]">Collections</a></li>
              <li><a href="#customers" className="text-white/70 hover:text-[#D4AF37]">Real Customers</a></li>
              <li><a href="#how" className="text-white/70 hover:text-[#D4AF37]">How it Works</a></li>
              <li><a href="#faq" className="text-white/70 hover:text-[#D4AF37]">FAQ</a></li>
              <li><a href="/pages/about" className="text-white/70 hover:text-[#D4AF37]">About Us</a></li>
              <li><a href="/pages/contact" className="text-white/70 hover:text-[#D4AF37]">Contact Us</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[0.65rem] uppercase tracking-[0.28em] text-[#D4AF37] mb-4">Connect</div>
            <ul className="space-y-3 text-sm">
              {s.whatsapp_number && (
                <li className="text-white/70 flex items-center gap-2">
                  <MessageCircle className="w-4 h-4 text-[#25D366]" />
                  {s.whatsapp_number}
                </li>
              )}
              {s.email && (
                <li>
                  <a href={`mailto:${s.email}`} className="text-white/70 hover:text-[#D4AF37] flex items-center gap-2" data-testid="footer-email">
                    <Mail className="w-4 h-4" /> {s.email}
                  </a>
                </li>
              )}
              {s.business_address && (
                <li className="text-white/70 flex items-start gap-2" data-testid="footer-address">
                  <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>{s.business_address}</span>
                </li>
              )}
              {s.instagram_url && (
                <li>
                  <a href={s.instagram_url} target="_blank" rel="noreferrer" className="text-white/70 hover:text-[#D4AF37] flex items-center gap-2">
                    <Instagram className="w-4 h-4" /> Instagram
                  </a>
                </li>
              )}
              {s.tiktok_url && (
                <li>
                  <a href={s.tiktok_url} target="_blank" rel="noreferrer" className="text-white/70 hover:text-[#D4AF37] flex items-center gap-2">
                    <Music2 className="w-4 h-4" /> TikTok
                  </a>
                </li>
              )}
              {s.facebook_url && (
                <li>
                  <a href={s.facebook_url} target="_blank" rel="noreferrer" className="text-white/70 hover:text-[#D4AF37] flex items-center gap-2">
                    <Facebook className="w-4 h-4" /> Facebook
                  </a>
                </li>
              )}
              <li className="pt-2">
                <Link to="/admin/login" className="text-white/35 hover:text-[#D4AF37] text-xs uppercase tracking-[0.22em]" data-testid="footer-admin-link">
                  Owner login
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="gold-hairline my-10" />

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[0.7rem] text-white/50 uppercase tracking-[0.16em] mb-6" data-testid="footer-policy-links">
          <a href="/pages/privacy" className="hover:text-[#D4AF37]">Privacy Policy</a>
          <a href="/pages/shipping" className="hover:text-[#D4AF37]">Shipping Policy</a>
          <a href="/pages/delivery" className="hover:text-[#D4AF37]">Delivery Policy</a>
          <a href="/pages/returns" className="hover:text-[#D4AF37]">Returns &amp; Refunds</a>
          <a href="/pages/terms" className="hover:text-[#D4AF37]">Terms &amp; Conditions</a>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-white/40 text-xs">
            © {new Date().getFullYear()} {s.brand_name || "Luxury Hair by DEMJ"}. All rights reserved.
          </div>
          <div className="text-white/30 text-xs tracking-[0.18em] uppercase">
            Premium Human Hair · Made for you
          </div>
        </div>
      </div>
    </footer>
  );
}
